import type { JSX, PropsWithChildren } from 'react';

import { StepStateContextProvider } from './context';
import { useStepState } from './hooks/useStepState';

export function StepStateProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element | null {
	const stepState = useStepState();

	return <StepStateContextProvider {...stepState}>{children}</StepStateContextProvider>;
}
